"use client";
import EyeIcon from "../icons/EyeIcon";
import EyeCloseIcon from "../icons/EyeCloseIcon";
import { FieldValues, FieldPath } from "react-hook-form";
import React, { useState } from "react";

import { InputCoreProps } from "../core/InputCore";

import InputLine from "./InputLine";
import { cn } from "@/utils/utils";
export interface InputPropsCustom {
	label?: string;
	type?: "email" | "password" | "search" | "tel" | "text" | "url";
	showError?: boolean;
}
function InputPassword<
	TFieldValues extends FieldValues,
	TName extends FieldPath<TFieldValues>
>(props: InputCoreProps<TFieldValues, TName> & InputPropsCustom) {


	const [isShowPass, setIsShowPass] = useState(false);

	return (
		<InputLine
			{...props}
			icon={
				<div
					onClick={() => {
						if (!props.disabled) {
							setIsShowPass(!isShowPass)
						}
					}}
					className={cn(props.disabled ? " cursor-default " : " cursor-pointer")}
				/>
			}

			autoComplete="off"
			type={isShowPass ? "text" : "password"}
		/>
	);
}
export default InputPassword;
